import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Modal } from '@instructure/ui-modal';
import { Heading } from '@instructure/ui-heading';
import { Checkbox, CheckboxGroup } from '@instructure/ui-checkbox';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { OUTSTANDING_QUIZZES_MODAL } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/es/format-message';
export var OutstandingQuizzesModal = /*#__PURE__*/function (_Component) {
  function OutstandingQuizzesModal(props) {
    var _this;
    _classCallCheck(this, OutstandingQuizzesModal);
    _this = _callSuper(this, OutstandingQuizzesModal, [props]);
    _defineProperty(_this, "saveAction", function () {
      var _iterator = _createForOfIteratorHelper(_this.state.quizzesSelectedAndReadyToSubmit),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var quiz = _step.value;
          _this.props.submitOutstandingQuizSession(quiz);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      _this.props.closeModal();
      _this.props.handleSubmissionAndPoll(_this.state.quizzesSelectedAndReadyToSubmit);
      _this.props.afterSubmit();
    });
    _defineProperty(_this, "cancelAction", function () {
      _this.props.onDismiss && _this.props.onDismiss();
      _this.props.closeModal();
    });
    _defineProperty(_this, "sortByName", function (arr) {
      return arr.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    });
    _defineProperty(_this, "generateCheckboxesForOutstandingQuizzes", function () {
      var checkboxes = [];
      var quizValues = [];
      var sortedQuizSessionIdsAndUsers = _this.sortByName(_this.props.quizSessionIdsAndUsers);
      if (sortedQuizSessionIdsAndUsers && _this.props.quizSessionsData) {
        sortedQuizSessionIdsAndUsers.forEach(function (sortedQuizSession) {
          return _this.props.quizSessionsData.filter(function (quizSession) {
            return quizSession.id === sortedQuizSession.id && quizSession.status === 'in_progress';
          }).forEach(function (quizSession) {
            quizValues.push(quizSession.id);
            checkboxes.push(/*#__PURE__*/React.createElement(Checkbox, {
              label: sortedQuizSession.name,
              value: quizSession.id,
              key: quizSession.id
            }));
          });
        });
      }
      return {
        checkboxes: checkboxes,
        quizValues: quizValues
      };
    });
    _defineProperty(_this, "updateListOfQuizzesToSubmit", function (value) {
      _this.setState({
        quizzesSelectedAndReadyToSubmit: value
      });
    });
    _defineProperty(_this, "closeModalOnClick", function () {
      _this.props.closeModal(OUTSTANDING_QUIZZES_MODAL);
    });
    _defineProperty(_this, "populateCheckboxesOnOpen", function () {
      var checkboxData = _this.generateCheckboxesForOutstandingQuizzes();
      _this.setState({
        quizzesSelectedAndReadyToSubmit: checkboxData.quizValues,
        checkboxes: checkboxData.checkboxes
      });
    });
    _this.state = {
      quizzesSelectedAndReadyToSubmit: [],
      checkboxes: []
    };
    return _this;
  }
  _inherits(OutstandingQuizzesModal, _Component);
  return _createClass(OutstandingQuizzesModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        open: this.props.open,
        onOpen: this.populateCheckboxesOnOpen,
        label: t('Attempts in Progress'),
        mountNode: this.props.mountNode,
        size: "small"
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Heading, null, t('Attempts in Progress')), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.closeModalOnClick,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("p", null, t('These assessment attempts have not been submitted. \
                  Instructors can submit attempts manually by selecting \
                  student name(s) from the list below.')), /*#__PURE__*/React.createElement(CheckboxGroup, {
        name: "outstandingQuizzesSubmissionCheckboxes",
        description: t('Students'),
        value: this.state.quizzesSelectedAndReadyToSubmit,
        onChange: this.updateListOfQuizzesToSubmit
      }, this.state.checkboxes)), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.cancelAction,
        margin: "xxx-small",
        "data-automation": "sdk-outstanding-quizzes-cancel"
      }, t('Cancel')), /*#__PURE__*/React.createElement(Button, {
        onClick: this.saveAction,
        margin: "xxx-small",
        color: "primary",
        disabled: !this.state.quizzesSelectedAndReadyToSubmit.length,
        "data-automation": "sdk-outstanding-quizzes-submit"
      }, t('Submit Manually'))));
    }
  }]);
}(Component);
_defineProperty(OutstandingQuizzesModal, "propTypes", {
  closeModal: PropTypes.func.isRequired,
  submitOutstandingQuizSession: PropTypes.func,
  open: PropTypes.bool,
  mountNode: PropTypes.string,
  onDismiss: PropTypes.func,
  quizSessionIdsAndUsers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  quizSessionsData: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  handleSubmissionAndPoll: PropTypes.func.isRequired,
  afterSubmit: PropTypes.func
});
_defineProperty(OutstandingQuizzesModal, "defaultProps", {
  submitOutstandingQuizSession: void 0,
  open: void 0,
  mountNode: null,
  onDismiss: null,
  closeModal: null,
  afterSubmit: Function.prototype
});
export default OutstandingQuizzesModal;